export const truncateTo1Decimal = (n: number): number => {
    return +(Math.trunc(n * 10) / 10);
};

export const truncateTo2Decimals = (n: number): number => {
    return +(Math.trunc(n * 100) / 100);
};

export const truncateTo3Decimals = (n: number): number => {
    return +(Math.trunc(n * 1000) / 1000);
};
export const roundTo0Decimal = (n: number) => {
    return +Math.round(n + Number.EPSILON);
};

export const roundTo1Decimal = (n: number) => {
    return +(Math.round((n + Number.EPSILON) * 10) / 10);
};

export const roundTo2Decimals = (n: number) => {
    return +(Math.round((n + Number.EPSILON) * 100) / 100);
};

export const roundTo3Decimals = (n: number) => {
    return +(Math.round((n + Number.EPSILON) * 1000) / 1000);
};
export const roundTo6Decimals = (n: number) => {
    return +(Math.round((n + Number.EPSILON) * 1000000) / 1000000);
};
